import React, { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { Tracking } from '~/services/tracking';

import {
  ErrorMessageWrapper,
  ErrorMessageWrapperProps,
} from '../error-message-wrapper/ErrorMessageWrapper';

export interface ErrorBoundaryWrapperProps {
  children: ReactNode;
  fallback?: ReactNode;
  resetKeys?: number[];
  onErrorCallback?: (error: Error) => void;
}

export const ErrorBoundaryWrapper = ({
  children,
  fallback,
  resetKeys,
  onErrorCallback,
  ...rest
}: ErrorBoundaryWrapperProps & ErrorMessageWrapperProps) => {
  const logError = (error: Error) => {
    Tracking.captureException(error);
  };

  return (
    <ErrorBoundary
      data-testid="error-boundary-wrapper"
      fallback={
        fallback !== undefined ? (
          fallback
        ) : (
          <ErrorMessageWrapper {...rest} displayIcon />
        )
      }
      onError={onErrorCallback ?? logError}
      resetKeys={resetKeys}
    >
      {children}
    </ErrorBoundary>
  );
};
